export enum DetachedClassificationAction {
    NONE = 0,
    CLEAR
}
